//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Plugin } from "ckeditor5";
import ConversationVariableEditing from "./conversationVariableEditing";
import ConversationVariableUi from "./conversationVariableUi";

export default class ConversationVariable extends Plugin {
  static get requires() {
    return [ConversationVariableEditing, ConversationVariableUi];
  }

  static get pluginName() {
    return "ConversationVariable";
  }
}
